//------------------------------------------------------------------------------
//
// Eschersketch - A drawing program for exploring symmetrical designs
//
//
// Copyright (c) 2026 Anselm Levskaya (http://anselmlevskaya.com)
// Licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
// license.
//
//------------------------------------------------------------------------------

// Network Configuration - online version with same-origin relative endpoints
//-------------------------------------------------------------------------------------
export const networkConfig = {
  networkEnabled:    true,
  shareURLPrefix:    "https://eschersket.ch/s/",
  SessionEndpoint:   "/api/session",
  SketchEndpoint:    "/api/sketch/",
  PostImageEndpoint: "/api/postimage",
  PostZazzleEndpoint: "/api/postimage",
  fbHref:            "https://www.facebook.com/dialog/share?app_id=1435026029878806&display=page&href=_MYURI_&redirect_uri=_MYURI_",
  twitterHref:       "https://twitter.com/intent/tweet?url=_MYURI_&text=Eschersketch",
  pinHref:           "https://pinterest.com/pin/create/button/?url=_MYURI_&media=_JPGURI_&description=an%20eschersketch",
  zazzleHref:        "https://www.zazzle.com/api/create/at-238457573239445416?rf=238457573239445416&ax=DesignBlast&sr=250849350115079504&cg=196081129722954021&t__useQpc=false&ed=true&t__smart=false&continueUrl=https%3A%2F%2Fwww.zazzle.com%2Feschersketch&tc=&ic=&t_image1_iid=_TILEIMGURI_",
};
